import { DEFAULT_TIMEZONE } from '@avanta/shared/constants/common';
import { ENTERPRISE_APPOINTMENT_FILTER } from 'constants/appointments';
import { useFetchEnterpriseAppointmentsCount } from 'hooks/useFetchEnterpriseAppointmentsCount';
import { useUserStore } from 'stores/user';
import { getCalendarDayInTz } from 'utils/date';

export const useSessionsSummary = (): {
  stats: { total: number; upcoming: number; previous: number; today: number };
  isLoading: boolean;
  isFetching: boolean;
} => {
  const timeZone = useUserStore(state => state.user?.timeZone) ?? DEFAULT_TIMEZONE;
  const today = getCalendarDayInTz(new Date(), timeZone);
  const totalQuery = useFetchEnterpriseAppointmentsCount();
  const upcomingQuery = useFetchEnterpriseAppointmentsCount({
    status: ENTERPRISE_APPOINTMENT_FILTER.UPCOMING,
  });
  const previousQuery = useFetchEnterpriseAppointmentsCount({
    status: ENTERPRISE_APPOINTMENT_FILTER.PAST,
  });
  const todayQuery = useFetchEnterpriseAppointmentsCount({
    dateFrom: today,
    dateTo: today,
  });

  return {
    stats: {
      total: totalQuery.data ?? 0,
      upcoming: upcomingQuery.data ?? 0,
      previous: previousQuery.data ?? 0,
      today: todayQuery.data ?? 0,
    },
    isLoading:
      totalQuery.isLoading ||
      upcomingQuery.isLoading ||
      previousQuery.isLoading ||
      todayQuery.isLoading,
    isFetching:
      totalQuery.isFetching ||
      upcomingQuery.isFetching ||
      previousQuery.isFetching ||
      todayQuery.isFetching,
  };
};
